import { useProjectScopePillFragment } from '../../../gql/generated/ProjectScopePill';

export const useScopedToProject = (projectId: string | null) => {
  const result = useProjectScopePillFragment({
    from: projectId
      ? {
          __typename: 'Project',
          id: projectId,
        }
      : null,
  });

  return result?.data ?? null;
};
